import { TOUR_STATE } from "@demandproai/shared";
import { TOUR_REFRESHER_AFTER_DAYS } from "../constants/tour";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const toTime = (value) => {
   if (!value) {
      return null;
   }

   const time = new Date(value).getTime();

   return Number.isNaN(time) ? null : time;
};

export const getDaysAway = ({ lastLoginAt, previousLoginAt }) => {
   const lastLogin = toTime(lastLoginAt);
   const previousLogin = toTime(previousLoginAt);

   // A first ever sign in has nothing to compare against, and is not a return
   if (lastLogin === null || previousLogin === null) {
      return null;
   }

   return Math.max(0, (lastLogin - previousLogin) / MS_PER_DAY);
};

// A finished tour comes back only for someone who has actually been away, and
// only once per absence: the offer is stamped against the sign in that earned
// it, so it reappears on the next long break rather than on the next page load
export const shouldOfferRefresher = ({
   tourState,
   lastLoginAt,
   previousLoginAt,
   afterDays = TOUR_REFRESHER_AFTER_DAYS,
}) => {
   const hasEnded = Boolean(
      tourState?.[TOUR_STATE.COMPLETED] || tourState?.[TOUR_STATE.DISMISSED]
   );

   if (!hasEnded) {
      return false;
   }

   const daysAway = getDaysAway({ lastLoginAt, previousLoginAt });

   if (daysAway === null || daysAway < afterDays) {
      return false;
   }

   const offeredAt = toTime(tourState?.[TOUR_STATE.REFRESHER_OFFERED]);
   const lastLogin = toTime(lastLoginAt);

   return offeredAt === null || offeredAt < lastLogin;
};
